import { render, staticRenderFns } from "./PlayerPause.vue?vue&type=template&id=f62fcf42"
import script from "./PlayerPause.vue?vue&type=script&lang=js"
export * from "./PlayerPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports